package ru.it_mozaika.sender.js.application.components.subscribers

import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.onChange
import ru.it_mozaika.sender.common.models.SubscriptionList
import ru.it_mozaika.sender.common.models.SubscriptionListUpdateRequest
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import web.cssom.AlignItems
import web.cssom.px

external interface AddSubscriptionDialogProps: Props {
    var isOpen: Boolean
    var onClose: () -> Unit
    var subscription: SubscriptionList?

}

val addSubscriptionListDialog = FC<AddSubscriptionDialogProps> { props ->
    val storeContext = useContext(StoreContext)
    val backdrop = useContext(BackdropContext)
    val (name, setName) = useState<String>()
    val (externalId, setExternalId) = useState<String>()
    val (isDisabled, setIsDisabled) = useState(false)
    val responseResult = useContext(RequestResultContext)
    useEffect(props.subscription){
        if (props.subscription == null){
            setName(null)
            setExternalId(null)
            setIsDisabled(false)
        } else {
            setName(props.subscription!!.name)
            setExternalId(props.subscription!!.externalId)
            storeContext.setStore(props.subscription!!.store)
            setIsDisabled(true)
        }
    }
//    val responseResult = useContext(RequestResultContext)
//    val navigate = useNavigate()

    Dialog {
        open = props.isOpen
        DialogTitle {
            +if (props.subscription == null) "Новый список подписок" else props.subscription!!.name
        }
        DialogContent {
            Stack {
                direction = responsive(StackDirection.column)
                spacing = responsive(2)
                sx {
                    padding = 5.px
                }
                TextField {
                    id = "subscription-list-name-field"
                    value = name ?: ""
                    disabled = isDisabled
                    label = ReactNode("Наименование:")
                    this.variant = FormControlVariant.outlined
                    error = name.isNullOrBlank()
                    required = true
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setName(value)
                    }
                }
                StoresSelect {
                    disabled = isDisabled
                }
                TextField {
                    id = "subscription-list-external-id-field"
                    value = externalId ?: ""
                    this.variant = FormControlVariant.outlined
                    disabled = isDisabled
                    label = ReactNode("Внешний ID: ")
//                    error = name.isNullOrBlank()
//                    required = true
                    this.onChange = { event ->
                        val value = event.target.asDynamic().value as String
                        setExternalId(value)
                    }
                }
            }
        }

        DialogActions {
            sx {
                alignItems = AlignItems.flexEnd
            }
            Stack {

                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    disabled = name.isNullOrBlank()
                    variant = ButtonVariant.outlined
                    this.color = ButtonColor.secondary
                    disabled = name.isNullOrBlank()
                    if (props.subscription == null) {
                        + "Создать"
                    } else {
                   + if (isDisabled) "Редактировать" else "Сохранить изменения"
                    }

                    this.onClick = {
                        if (props.subscription == null) {
                            backdrop.show()
                            if (!name.isNullOrBlank() && storeContext.currentStoreId != null) {
                                Http.put(
                                    "/subscribers/lists",
                                    body = SubscriptionListUpdateRequest(
                                        name = name,
                                        store = storeContext.currentStoreId!!,
                                        externalId = externalId
                                    ),
                                    callback = { response ->
                                        backdrop.hide()
                                        responseResult.handleRequestRespond(response)
                                        props.onClose()
                                    }
                                )
                            }
                        }else {
                            if (isDisabled) {
                                setIsDisabled(false)
                            } else {
                                if (!name.isNullOrBlank() && storeContext.currentStoreId != null) {
                                    backdrop.show()
                                    Http.post(
                                        "/subscribers/lists/${props.subscription!!.id}",
                                        query = mapOf("id" to props.subscription!!.id),
                                        body = SubscriptionListUpdateRequest(name, externalId = externalId, store = storeContext.currentStoreId!!)
                                    ) { response ->
                                        responseResult.handleRequestRespond(response)
                                        backdrop.hide()
                                        props.onClose()
                                    }
                                }
                            }
                        }
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
//                                props.onClose()
                    }
                }
            }
        }

    }
}